import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from 'environment';

import {Credentials} from '../model/interfaces';

const HTTP_OK_CODE: number = 200;

type ChangeCredentialsData = {
  oldPassword: string;
  newPassword: string;
};

@Injectable()
export class LoginRepository {

  constructor(private http: HttpClient) { }

  public login(username: string, password: string): Observable<boolean> {

    const headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    const body: Credentials = {
      username: username,
      password: password,
    };

    return this.http
      .post(environment.auth.loginRoute, body, {headers: headers, observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE));
  }

  public logout(): Observable<boolean> {
    return this.http
      .post(environment.auth.logoutRoute, {}, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE));
  }

  public resetPassword(username: string): Observable<boolean> {
    const suffix: string = '/' + encodeURI(username);

    return this.http
      .post(environment.auth.resetPasswordRoute + suffix, {}, {observe: 'response', responseType: 'text'})
      .pipe(map((response) => response.status === HTTP_OK_CODE));
  }

  public changePassword(oldPassword: string, newPassword: string): Observable<boolean> {

    const body: ChangeCredentialsData = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    return this.http
      .put(environment.auth.changePasswordRoute, body, {observe: 'response', responseType: 'text', withCredentials: true})
      .pipe(map((response) => response.status === HTTP_OK_CODE));
  }
}
